import React from 'react';
import CSSModules from './index.module.less';

import { isWebInApp } from '@helpers/Constants';

// import NativeInterface from '@helpers/NativeInterface';
import BrowserHistory, { canGo } from '@helpers/BrowserHistory';
import { getNativeProxySington } from '@helpers/NativeProxy';

interface IProps {
  title?: string;
  rightBtnText?: string;
  TitleComponent?:React.ReactNode;
  BackBtnComponent?: React.ReactNode;
  RightBtnComponent?: React.ReactNode;
  onClickBackBtn?: () => void;
  onClickRightBtn?: () => void;
  transparent?: boolean;
  className?: string;
  styleName?: string;
  hideBackButton?: boolean;
}

const NavBar = (props: IProps) => {
  const {
    title,
    TitleComponent,
    rightBtnText,
    RightBtnComponent,
    BackBtnComponent,
    onClickBackBtn,
    onClickRightBtn,
    transparent,
    className,
    hideBackButton
  } = props;

  const back = async() => {
    if(typeof onClickBackBtn === 'function') {
      onClickBackBtn();
    } else {
      if(isWebInApp() && !canGo(-1)) {
        const np = await getNativeProxySington('seewoCube')
        await np.asyncInvoke({
          name: 'postMessage',
          params: {
            command: 'command_close_container',
            extras: {}
          }
        })
      }
      BrowserHistory.goBack();
    }
  }

  const clickRightBtn = () => {
    onClickRightBtn && onClickRightBtn();
  }

  let customClass = className ? ' ' + className : '';
    customClass += transparent ? ' ' + CSSModules.transparent : '';

  return(
    <div styleName="nav" className={ "flex flex-center " + customClass }>
      <div styleName="left">
        {
          !hideBackButton ? (BackBtnComponent || (
            <div styleName="nav-back" onClick={ back }><i className="iconfont icon-tubiaoyanse" /></div>
          )): null
        }
      </div>
      { TitleComponent || <div styleName="nav-title" className="els">{ title || '' } </div>}
      <div styleName="right">
        {
          RightBtnComponent ||  (
            <>
              {
                rightBtnText ? (
                  <div styleName="right-btn" onClick={clickRightBtn}>{rightBtnText || ''}</div>
                ) : null
              }
            </>
          )
        }
      </div>
    </div>
  )
}

export default NavBar;